import { AddOns } from '@racemap/sdk/schema/billing/AddOns';
import { EventTypes } from '@racemap/sdk/schema/events';

export const getAddOnsOfEventType = (eventType: EventTypes | undefined): Array<AddOns> => {
  if (eventType == null) return [];

  switch (eventType) {
    case EventTypes.SAFEMAP:
      return [AddOns.PARTICIPANTS, AddOns.TRACKER_RENTAL];
    case EventTypes.REGULAR:
    case EventTypes.CONTEST:
    case EventTypes.STAGE:
      return [
        AddOns.PREDICTIVE,
        AddOns.PARTICIPANTS,
        AddOns.TRACKER_RENTAL,
        AddOns.TIMING,
        AddOns.SPONSOR,
        AddOns.API,
        AddOns.KEYS,
        AddOns.HIGH_RESOLUTION,
      ];
    case EventTypes.CONTEST_GROUP:
      return [];
    case EventTypes.STAGE_GROUP:
      return [AddOns.PARTICIPANTS, AddOns.TIMING, AddOns.KEYS];
    default:
      throw new Error(`Unknown event type: ${eventType}`);
  }
};
